(() => {
  // scripts/shopify/tools.ts
  var ON_CART_FINISHED = "cart:finished";
  var CART_EVENTS = {
    UPDATED: "cart:updated",
    ITEM_ADDED: "cart:itemAdded",
    ITEM_REMOVED: "cart:itemRemoved"
  };
  var dispatchCartEvent = (name, detail) => {
    window.dispatchEvent(new CustomEvent(name, { detail }));
  };
  var headers = {
    "Content-Type": "application/json",
    Accept: "application/json"
  };
  var cartGetCurrent = async () => {
    const res = await fetch("/cart.js", { method: "GET", headers });
    if (!res.ok) throw new Error("Failed to fetch cart");
    return res.json();
  };
  var cartAdd = async (input) => {
    const items = Array.isArray(input) ? input : input.items;
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers,
      body: JSON.stringify({ items })
    });
    if (!res.ok) throw new Error("Failed to add items");
    const cart = await res.json();
    items.forEach((i) => {
      var _a;
      return dispatchCartEvent(CART_EVENTS.ITEM_ADDED, { id: i.id, quantity: (_a = i.quantity) != null ? _a : 1 });
    });
    dispatchCartEvent(CART_EVENTS.UPDATED, { action: "add", items });
    dispatchCartEvent(ON_CART_FINISHED, { action: "add" });
    return cart;
  };
  var cartUpdate = async (input) => {
    let updates = {};
    if (Array.isArray(input)) {
      input.forEach(({ line, quantity }) => {
        updates[String(line)] = quantity;
      });
    } else if (Array.isArray(input.updates)) {
      input.updates.forEach(({ line, quantity }) => {
        updates[String(line)] = quantity;
      });
    } else {
      updates = input.updates;
    }
    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers,
      body: JSON.stringify({ updates })
    });
    if (!res.ok) throw new Error("Failed to update cart");
    const cart = await res.json();
    const removedLines = Object.entries(updates).filter(([, qty]) => qty === 0).map(([line]) => Number(line));
    removedLines.forEach((line) => dispatchCartEvent(CART_EVENTS.ITEM_REMOVED, { line }));
    dispatchCartEvent(CART_EVENTS.UPDATED, { action: "update", updates });
    dispatchCartEvent(ON_CART_FINISHED, { action: "update" });
    return cart;
  };

  // scripts/tools/classes.ts
  var CLASS_ACTIVE = "is-active";
  var CLASS_SCROLL_DISABLED = "is-scroll-disabled";
  var CLASS_DRAWER_OPEN = "is-drawer-open";
  var CLASS_CART_PENDING = "is-cart-pending";
  var CLASS_HAS_ITEMS = "has-items";

  // scripts/sections/cart.ts
  var SELECTOR_CONTAINER = "[data-cart-container]";
  var SELECTOR_TOGGLE = "[data-cart-drawer-toggle]";
  var SELECTOR_SHOPIFY_SECTION = "#shopify-section-cart-contents";
  var SELECTOR_UPSELL_ADD = "[data-upsell-add-btn]";
  var SELECTOR_ITEM_REMOVE = "[data-remove-link]";
  var SELECTOR_CART_COUNT = "[data-header-cart-counter]";
  var ATTR_ITEM_REMOVE = "data-remove-link";
  var ATTR_VARIANT = "data-variant";
  var body = document.body;
  document.querySelectorAll(SELECTOR_CONTAINER).forEach((container) => {
    let contentsRendered = false;
    let cartOpen = false;
    let addUpsellBtns;
    let removeItemBtns;
    let toggleBtns;
    addEventListeners();
    window.addEventListener(ON_CART_FINISHED, (e) => onCartFinished(e));
    function addEventListeners() {
      refreshElements();
      addUpsellBtns.forEach((btn) => btn.addEventListener("click", onAddUpsell));
      removeItemBtns.forEach((btn) => btn.addEventListener("click", onRemoveItem));
      toggleBtns.forEach((btn) => btn.addEventListener("click", onCartToggle));
      if (window.location.search === "?cart") {
        if (!contentsRendered) renderCartContents();
        contentsRendered = true;
        openCart();
      }
    }
    function removeEventListeners() {
      addUpsellBtns.forEach((btn) => btn.removeEventListener("click", onAddUpsell));
      removeItemBtns.forEach((btn) => btn.removeEventListener("click", onRemoveItem));
      toggleBtns.forEach((btn) => btn.removeEventListener("click", onCartToggle));
    }
    function refreshElements() {
      addUpsellBtns = container.querySelectorAll(SELECTOR_UPSELL_ADD);
      removeItemBtns = container.querySelectorAll(SELECTOR_ITEM_REMOVE);
      toggleBtns = document.querySelectorAll(SELECTOR_TOGGLE);
    }
    async function onCartFinished() {
      var _a;
      await renderCartContents();
      if (!cartOpen && !isCartPage()) setTimeout(() => openCart(), 500);
      const countElements = document.querySelectorAll(SELECTOR_CART_COUNT);
      if (!countElements) return;
      const cart = await cartGetCurrent();
      const count = (_a = cart == null ? void 0 : cart.item_count) != null ? _a : 0;
      countElements.forEach((countElement) => {
        countElement.innerHTML = `(${count.toString()})`;
        if (count > 0) {
          countElement.classList.add(CLASS_HAS_ITEMS);
        } else {
          countElement.classList.remove(CLASS_HAS_ITEMS);
        }
      });
    }
    function onCartToggle(e) {
      e.preventDefault();
      if (!cartOpen) {
        if (!contentsRendered) renderCartContents();
        contentsRendered = true;
        openCart();
      } else {
        closeCart();
      }
    }
    function openCart() {
      container.classList.add(CLASS_DRAWER_OPEN);
      body.classList.add(CLASS_DRAWER_OPEN);
      body.classList.add(CLASS_SCROLL_DISABLED);
      toggleBtns.forEach((btn) => btn.classList.add(CLASS_ACTIVE));
      cartOpen = true;
    }
    function closeCart() {
      container.classList.remove(CLASS_DRAWER_OPEN);
      body.classList.remove(CLASS_DRAWER_OPEN);
      body.classList.remove(CLASS_SCROLL_DISABLED);
      toggleBtns.forEach((btn) => btn.classList.remove(CLASS_ACTIVE));
      cartOpen = false;
    }
    function isCartPage() {
      return window.location.href.includes("/cart");
    }
    async function onAddUpsell(e) {
      e.preventDefault();
      const target = e.target;
      const button = target.closest(SELECTOR_UPSELL_ADD);
      const variant = button == null ? void 0 : button.getAttribute(ATTR_VARIANT);
      if (!variant) return;
      try {
        await cartAdd({
          items: [{
            id: parseInt(variant),
            quantity: 1
          }]
        });
      } catch (e2) {
        console.error("Failed to add to cart.");
        return;
      }
    }
    async function onRemoveItem(e) {
      e.preventDefault();
      const target = e.target;
      const button = target.closest(SELECTOR_ITEM_REMOVE);
      const line = button == null ? void 0 : button.getAttribute(ATTR_ITEM_REMOVE);
      const itemsToRemove = {};
      if (line) {
        itemsToRemove[line] = 0;
      }
      try {
        if (Object.keys(itemsToRemove).length) {
          await cartUpdate({
            updates: itemsToRemove
          });
        }
      } catch (e2) {
        console.error("Failed to remove from cart.");
        return;
      }
    }
    async function renderCartContents() {
      body.classList.add(CLASS_CART_PENDING);
      removeEventListeners();
      const sectionHtml = await fetch(`/?sections=cart-contents`).then((res) => {
        return res.json();
      }).then((res) => res["cart-contents"]);
      const html = document.createElement("div");
      html.innerHTML = sectionHtml;
      const sectionWrapper = html.querySelector(SELECTOR_SHOPIFY_SECTION);
      if (!sectionWrapper) {
        return console.warn("Invalid markup detected in the Cart Drawer section.");
      }
      container.innerHTML = String(sectionWrapper.outerHTML);
      addEventListeners();
      body.classList.remove(CLASS_CART_PENDING);
    }
  });
})();
